document.addEventListener("DOMContentLoaded", function () {

  const STORAGE_KEY = "recently_viewed";
  const MAX_ITEMS = 10;
  const SHOW_ITEMS = 4;
  const WRAPPER_ID = "recently-viewed-products";

  // 🔹 Get current product handle
  function getProductHandle() {
    const match = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/);
    return match ? match[1] : null;
  }

  // 🔹 Save recently viewed
  function saveRecentlyViewed(handle) {
    if (!handle) return;

    let items = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

    items = items.filter(item => item !== handle);
    items.unshift(handle);

    if (items.length > MAX_ITEMS) {
      items = items.slice(0, MAX_ITEMS);
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  // 🔹 Fetch product JSON
  function fetchProduct(handle) {
    return fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .catch(() => null);
  }

  // 🔹 Resize Shopify image (no dependency)
  function resizeImage(url, size = "600x") {
    if (!url) return "https://via.placeholder.com/600";

    return url
      .replace(/(\.[^.]*)$/, `_${size}$1`)
      .replace(/^\/\//, "https://");
  }

  // 🔹 Create product HTML
  function createProductHTML(product) {
    const image = product.featured_image || (product.images && product.images[0]) || '';
    const imageUrl = resizeImage(image, "600x");

    const price = Shopify.formatMoney(product.price, window.money_format);

    let priceHTML = `<span>${price}</span>`;

    if (product.compare_at_price > product.price) {
      priceHTML = `
        <del>${Shopify.formatMoney(product.compare_at_price, window.money_format)}</del>
        <span>${price}</span>
      `;
    }

    return `
      <div class="recently-viewed-product product-item col-6 col-sm-6 col-md-4 col-lg-3">
        <div class="ltn__product-item ltn__product-item-3 text-center">

          <div class="product-img">
            <a href="/products/${product.handle}">
              <img 
                src="${imageUrl}" 
                alt="${product.title}" 
                loading="lazy"
              />
            </a>
          </div>

          <div class="product-info">
            <h2 class="product-title">
              <a href="/products/${product.handle}">${product.title}</a>
            </h2>

            <div class="product-price">
              ${priceHTML}
            </div>
          </div>

        </div>
      </div>
    `;
  }

  // 🔹 Render products
  async function renderRecentlyViewed() {
    const wrapper = document.getElementById(WRAPPER_ID);
    if (!wrapper) return;

    let items = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    items = items.slice(0, SHOW_ITEMS);

    if (!items.length) return;

    const products = await Promise.all(items.map(fetchProduct));
    const validProducts = products.filter(Boolean);

    wrapper.innerHTML = validProducts.map(createProductHTML).join("");
  }

  // 🔹 Init
  const currentHandle = getProductHandle();
  saveRecentlyViewed(currentHandle);
  renderRecentlyViewed();

});